import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import HeroCarousel from '../components/HeroCarousel';
import ContactForm from '../components/ContactForm';
import PlanosAvulsos from '../components/PlanosAvulsos';
import FaqSection from '../components/FaqSection';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';
import './HomePage.css';
import './ContactSection.css';

const HOME_WHATSAPP_URL = 'https://wa.me/5521987940668?text=Ola!%20Quero%20consultar%20a%20viabilidade%20de%20internet%20para%20o%20meu%20endereco.';

function HomePage() {
  const heroMsaRef = useRef(null);
  const planosRef = useRef(null);
  const contactRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  // Rola até o FAQ quando a Home é aberta a partir do link FAQ do navbar em outra página
  useEffect(() => {
    if (location.state?.scrollTo === 'faq') {
      const timer = window.setTimeout(() => {
        document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        navigate(location.pathname, { replace: true, state: {} });
      }, 150);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [location.state, location.pathname, navigate]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    if (heroMsaRef.current) observer.observe(heroMsaRef.current);
    if (planosRef.current) observer.observe(planosRef.current);
    if (contactRef.current) observer.observe(contactRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div>
      {/* Seção apresentação - Banner Faynet */}
      <section className="hero-msa" ref={heroMsaRef}>
        <div className="hero-msa__banner">
          <HeroCarousel />
        </div>
      </section>

      {/* Seção Planos de internet avulsa */}
      <section className="home-planos" ref={planosRef}>
        <div className="home-planos__cta">
          <p className="home-planos__cta-text">Precisa de ajuda ou tem alguma dúvida? Fale com um de nossos especialistas</p>
          <a
            href={HOME_WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            className="home-planos__cta-btn"
          >
            CHAMAR NO WHATSAPP
          </a>
        </div>
        <div className="home-planos__header">
          <span className="home-planos__eyebrow">Planos de internet</span>
          <h2 className="home-planos__title">Escolha o plano ideal para você</h2>
        </div>
        <div className="home-planos__wrapper">
          <PlanosAvulsos showViewAllLink />
        </div>
      </section>

      {/* Depoimentos de Clientes */}
      <Testimonials />

      {/* Seção Fale Conosco */}
      <section className="contact-section" ref={contactRef}>
        <div className="contact-section__wrapper">
          {/* Lado esquerdo - Formulário */}
          <div className="contact-section__left">
            <div className="contact-section__header">
              <h2 className="contact-section__title">Fale com a Faynet</h2>
              <p className="contact-section__subtitle">
                Dúvidas, planos, parcerias, reclamacoes ou qualquer outro assunto: preencha o formulário e nossa equipe entrará em contato em até 24 horas.
              </p>
            </div>
            <ContactForm />
          </div>

          {/* Lado direito - Imagem Notebook */}
          <div className="contact-section__right">
            <img 
              src="/index/inicio3.png" 
              alt="Sistema MSA Porta Paletes - Tecnologia e Inovação" 
              className="contact-section__image"
            />
          </div>
        </div>
      </section>

      {/* Perguntas frequentes */}
      <FaqSection />

      <Footer />
    </div>
  );
}

export default HomePage;
